import * as React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import './App.scss';
import Ribbon from './Ribbon';
import Footer from './Footer';
import IUser from './models/IUser';
import { AppContext } from './contexts/AppContext';
import ManageCert from './ManageCert';
import LookupCert from './LookupCert';

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import {setupAppWindowTracking} from "./util/SetupAppWindowTracking";

interface IAppProps {

}

interface IAppState {
    ready: boolean;
    user?: IUser;
}

setupAppWindowTracking();

export default class App extends React.PureComponent<IAppProps, IAppState> {
    constructor(props: IAppProps) {
        super(props);
        this.state = {ready: false};
    }

    async componentDidMount() {
        //Get current user
        let response = await fetch('/api/user');
        if (response.ok) {
            //We are signed on and know our user
            let userData = await response.json() as IUser;
            this.setState({ ready: true, user: userData });
        }
        else {
            //We are not signed on yet, so get authenticated first
            //The ribbon may authenticate us later
            this.setState({ ready: true, user: undefined });
        }
    }
    render() {
        return (
            <AppContext.Provider value={{ user: this.state.user }}>
                <div className="App">
                    <Ribbon />
                    {this.state.ready &&
                        <BrowserRouter>
                            <Switch>
                                <Route exact path="/" component={this.state.user != null ? ManageCert : LookupCert} />
                                <Route path="/managecert" component={ManageCert} />
                                <Route path="/verifycert" component={ManageCert /*Not a mistake, ManageCert aldo does verification*/} />
                                <Route path="/lookupcert" component={LookupCert} />
                            </Switch>
                        </BrowserRouter>
                    }
                    <div className="whiteSpace"></div>
                    <Footer />
                </div>
            </AppContext.Provider>
        );
    }
}